import {
  CrownIcon,
  FileText,
  PlusCircleIcon,
  User,
  RecycleIcon,
  SettingsIcon,
  Tag,
  TrashIcon,
  LayoutDashboard,
  Smartphone,
  Folders,
  MonitorPlay,
  UserCheck,
  PanelsTopLeft,
  ContactRound,
  Users,
  Star,
  TicketPercent,
  Share2,
  MonitorCog,
  FileChartColumnIncreasing,
  Images,
  LayoutList,
  Gem,
  MessageSquare,
  TvMinimalPlay,
  Package,
  Archive,
  BookOpen,
  Wallet,
  ShoppingBag,
  XCircle,
  Clock,
  CheckCircle2,
  PackageCheck,
  Truck,
  MapPin,
  Smile,
  Ban,
  RotateCcw,
  Undo2,
  RefreshCcw,
  AlertCircle,
  PauseCircle,
  Banknote,
  CreditCard,
  Gift,
} from 'lucide-react';

export const ITEM_TYPES = {
  1: 'Digital Files',
  2: 'Subscription Package',
  // 3: 'Digital Product',
  // 4: 'Courses',
  5: 'Wallet Recharge',
  // 6: 'Physical Product',
};

export const ITEM_TYPE_DETAILS = {
  1: {
    label: 'Digital Files',
    icon: FileText,
    color: 'bg-sky-50 text-sky-700 border-sky-200',
  },
  2: {
    label: 'Subscription Package',
    icon: Package,
    color: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  },
  3: {
    label: 'Digital Product',
    icon: Archive,
    color: 'bg-amber-50 text-amber-700 border-amber-200',
  },
  4: {
    label: 'Courses',
    icon: BookOpen,
    color: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  5: {
    label: 'Wallet Recharge',
    icon: Wallet,
    color: 'bg-rose-50 text-rose-700 border-rose-200',
  },
  6: {
    label: 'Physical Product',
    icon: ShoppingBag,
    color: 'bg-slate-50 text-slate-700 border-slate-200',
  },
};

export const PRODUCT_TYPE = {
  1: 'Digital Product',
  2: 'Physical Product',
};

export const PRODUCT_STATUS = {
  1: 'Draft',
  2: 'Active',
  3: 'Inactive',
  4: 'Archived',
};

export const PAYMENT_STATUS = {
  0: 'Cancelled',
  1: 'Pending',
  2: 'Paid',
  3: 'Failed',
  4: 'Refunded',
};

export const PAYMENT_STATUS_DETAILS = {
  0: {
    label: 'Cancelled',
    icon: XCircle,
    color: 'bg-rose-50 text-rose-700 border-rose-200',
  },
  1: {
    label: 'Pending',
    icon: Clock,
    color: 'bg-yellow-50 text-yellow-700 border-yellow-200',
  },
  2: {
    label: 'Paid',
    icon: CheckCircle2,
    color: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  3: {
    label: 'Failed',
    icon: XCircle,
    color: 'bg-rose-50 text-rose-700 border-rose-200',
  },
  4: {
    label: 'Refunded',
    icon: RotateCcw,
    color: 'bg-sky-50 text-sky-700 border-sky-200',
  },
};

export const ORDER_STATUS = {
  1: 'Pending', // Order placed but no further action yet.
  2: 'Accepted', // Order accepted by the seller.
  3: 'Processing', // Order is being prepared (packing or generating access).
  4: 'Shipped', // For physical products: Order dispatched.
  5: 'Out for Delivery', // For physical products: Out for final delivery.
  6: 'Delivered', // Order successfully delivered to the customer.
  7: 'Completed', // Order completed and closed.
  8: 'Cancelled', // Order was cancelled by the customer or seller.
  9: 'Returned', // Physical product returned by the customer.
  10: 'Refunded', // Order payment refunded to the customer.
  11: 'Partially Fulfilled', // Only part of the order was fulfilled.
  12: 'On Hold', // Order is paused pending some action.
};

export const ORDER_STATUS_DETAILS = {
  0: {
    label: 'Failed',
    icon: Ban,
    color: 'bg-rose-50 text-rose-700 border-rose-200',
  },
  1: {
    label: 'Pending',
    icon: Clock,
    color: 'bg-yellow-50 text-yellow-700 border-yellow-200',
  },
  2: {
    label: 'Accepted',
    icon: CheckCircle2,
    color: 'bg-blue-50 text-blue-700 border-blue-200',
  },
  3: {
    label: 'Processing',
    icon: PackageCheck,
    color: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  },
  4: {
    label: 'Shipped',
    icon: Truck,
    color: 'bg-sky-50 text-sky-700 border-sky-200',
  },
  5: {
    label: 'Out for Delivery',
    icon: MapPin,
    color: 'bg-cyan-50 text-cyan-700 border-cyan-200',
  },
  6: {
    label: 'Delivered',
    icon: Smile,
    color: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  7: {
    label: 'Completed',
    icon: CheckCircle2,
    color: 'bg-green-50 text-green-700 border-green-200',
  },
  8: {
    label: 'Cancelled',
    icon: Ban,
    color: 'bg-rose-50 text-rose-700 border-rose-200',
  },
  9: {
    label: 'Returned',
    icon: Undo2,
    color: 'bg-pink-50 text-pink-700 border-pink-200',
  },
  10: {
    label: 'Refunded',
    icon: RotateCcw,
    color: 'bg-teal-50 text-teal-700 border-teal-200',
  },
  11: {
    label: 'Partially Fulfilled',
    icon: RefreshCcw,
    color: 'bg-gray-50 text-gray-700 border-gray-200',
  },
  12: {
    label: 'On Hold',
    icon: PauseCircle,
    color: 'bg-orange-50 text-orange-700 border-orange-200',
  },
};

export const PAYMENT_METHOD = {
  1: 'Razorpay',
  2: 'Manual',
  3: 'Account Balance',
  4: 'Binance',
  5: 'Cashfree',
  6: 'PayPal',
  7: 'INR Portal',
  8: 'Coin Flex Pay',
  9: 'Free Order',
};

export const PAYMENT_METHOD_DETAILS = {
  1: {
    label: 'Razorpay',
    icon: CreditCard,
    color: 'bg-blue-50 text-blue-700 border-blue-200',
  },
  2: {
    label: 'Manual',
    icon: Banknote,
    color: 'bg-orange-50 text-orange-700 border-orange-200',
  },
  3: {
    label: 'Account Balance',
    icon: Wallet,
    color: 'bg-blue-50 text-blue-700 border-blue-200',
  },
  4: {
    label: 'Binance',
    icon: CreditCard,
    color: 'bg-purple-50 text-purple-700 border-purple-200',
  },
  5: {
    label: 'Cashfree',
    icon: CreditCard,
    color: 'bg-purple-50 text-purple-700 border-purple-200',
  },
  6: {
    label: 'PayPal',
    icon: CreditCard,
    color: 'bg-blue-50 text-blue-700 border-blue-200',
  },
  7: {
    label: 'INR Portal',
    icon: Banknote,
    color: 'bg-green-50 text-green-700 border-green-200',
  },
  8: {
    label: 'Coin Flex Pay',
    icon: CreditCard,
    color: 'bg-purple-50 text-purple-700 border-purple-200',
  },
  9: {
    label: 'Free Order',
    icon: Gift,
    color: 'bg-blue-50 text-blue-700 border-blue-200',
  },
};

export const DOWNLOAD_STATUS = {
  true: {
    value: true,
    label: 'Active',
    icon: CheckCircle2,
    color: 'bg-green-50 text-green-700 border-green-200',
  },
  false: {
    value: false,
    label: 'Expired',
    icon: XCircle,
    color: 'bg-red-50 text-red-700 border-red-200',
  },
};

export const sidebarMenuItems = [
  {
    title: 'Dashboard',
    label: '',
    icon: LayoutDashboard,
    link: '/dashboard',
  },
  {
    title: 'Users',
    label: '',
    icon: User,
    link: '/users',
  },
  {
    title: 'Orders',
    label: '',
    icon: Tag,
    link: '/orders',
  },
  {
    title: 'Files',
    label: '',
    icon: Folders,
    link: '/files',
  },
  {
    title: 'Download Package',
    label: '',
    icon: CrownIcon,
    link: '/download-packages',
  },
  {
    category: 'CMS',
    icon: MonitorCog,
    items: [
      {
        title: 'Pages',
        label: '',
        icon: FileText,
        link: '/pages',
      },
      {
        title: 'Teams',
        label: '',
        icon: Users,
        link: '/teams',
      },
      {
        title: 'Menu',
        label: '',
        icon: PanelsTopLeft,
        link: '/menu',
      },
      {
        title: 'Agents',
        label: '',
        icon: UserCheck,
        link: '/agents',
      },
      {
        title: 'Reviews',
        label: '',
        icon: Star,
        link: '/reviews',
      },
      {
        title: 'Videos',
        label: '',
        icon: MonitorPlay,
        link: '/videos',
      },
      {
        title: 'Social Platforms',
        label: '',
        icon: Share2,
        link: '/social-platforms',
      },
    ],
  },
  {
    category: 'Reports',
    icon: FileChartColumnIncreasing,
    items: [
      {
        title: 'User Packages Reports',
        label: '',
        icon: Package,
        link: '/user-packages-reports',
      },
      {
        title: 'User Packages Data',
        label: '',
        icon: Package,
        link: '/user-packages-data',
      },
      {
        title: 'Leads',
        label: '',
        icon: ContactRound,
        link: '/leads',
      },
      {
        title: 'Request Files',
        label: '',
        icon: Smartphone,
        link: '/request-files',
      },
      {
        title: 'Invoices',
        label: '',
        icon: FileText,
        link: '/invoices',
      },
    ],
  },
  {
    category: 'Blogs',
    icon: PlusCircleIcon,
    items: [
      {
        title: 'Blogs',
        label: '',
        icon: PlusCircleIcon,
        link: '/blogs',
      },
      {
        title: 'Categories',
        label: '',
        icon: FileText,
        link: '/blogs/categories',
      },
      {
        title: 'Tags',
        label: '',
        icon: Tag,
        link: '/blogs/tags',
      },
    ],
  },
  {
    category: 'Products',
    icon: ShoppingBag,
    items: [
      {
        title: 'Products',
        label: '',
        icon: LayoutList,
        link: '/products',
      },
      {
        title: 'Attributes',
        label: '',
        icon: LayoutList,
        link: '/products/attributes',
      },
      {
        title: 'Categories',
        label: '',
        icon: FileText,
        link: '/products/categories',
      },
      {
        title: 'Tags',
        label: '',
        icon: Tag,
        link: '/products/tags',
      },
    ],
  },
  {
    category: 'Courses',
    icon: TvMinimalPlay,
    items: [
      {
        title: 'Courses',
        label: '',
        icon: LayoutList,
        link: '/courses',
      },
      {
        title: 'Categories',
        label: '',
        icon: FileText,
        link: '/courses/categories',
      },
      {
        title: 'Tags',
        label: '',
        icon: Tag,
        link: '/courses/tags',
      },
    ],
  },
  {
    title: 'Discounts',
    label: '',
    icon: TicketPercent,
    link: '/discounts',
  },
  {
    title: 'Settings',
    label: '',
    icon: SettingsIcon,
    link: '/settings',
  },
  {
    title: 'Media',
    label: '',
    icon: Images,
    link: '/media',
  },
  {
    title: 'Chat',
    label: '',
    icon: MessageSquare,
    link: '/chat',
  },
];

export const socialPlatforms = [
  'Facebook',
  'Twitter',
  'Instagram',
  'LinkedIn',
  'YouTube',
  'TikTok',
  'Pinterest',
  'Reddit',
  'Snapchat',
  'Discord',
  'Twitch',
  'Medium',
  'Tumblr',
  'Vimeo',
  'Quora',
];
